module.exports = __webpack_public_path__ + "static/media/CTLA_5-540w.40544f91.jpg";